<template>
	<c-callout type="error">
		<p>
			{{ noAccountMessage }}
			<template v-if="promptSignup">
				<br>
				<button class="button--anchor matins" title="Sign up for Cognito Forms" @click="$emit('signup')">Would you like to sign up</button>?
			</template>
		</p>
	</c-callout>
</template>

<script lang="ts">
	import CCallout from '@cognitoforms/shared-components/src/components/content/Callout.vue';
	import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
	import { computed, defineComponent } from 'vue';
	export default defineComponent({
		components: { CCallout },
		props: {
			promptSignup: Boolean,
			emailAddress: {
				type: String,
				required: true
			}
		},
		emits: ['signup'],
		setup(props) {
			const noAccountMessage = computed<string>(() => {
				let message = 'We couldn\'t find a';
				if (CognitoConfiguration.NewLoginEnabled)
					message += 'n account';
				else
					message += ' Cognito Forms account';

				return message + ` for ${props.emailAddress}.`;
			});
			return {
				noAccountMessage
			};
		}
	});
</script>
